<template lang="html">
  <div>
    <transition name="slide-fade">
      <CookieConsent v-show="$store.getters['cookies/isVisible'] && !$cms" :locale="locale" />
    </transition>
    <div class="layout">
      <header class="layout__header">
        <slot name="header" />
      </header>
      <div class="layout__main">
        <slot />
      </div>
      <footer class="layout__footer">
        <slot name="footer" />
      </footer>
      <slot name="afterFooter" />
      <div class="footer-background-fix" />
      <div class="transition-rect" />
    </div>
  </div>
</template>

<script>
import CookieConsent from 'beisheim/components/elements/cookie-consent'
import throttle from 'lodash/throttle'

function hasWindow () {
  return typeof window !== 'undefined'
}

export default {
  components: {
    CookieConsent
  },
  props: {
    locale: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      throttleScrollHandler: throttle(this.setViewportScroll, 200),
      throttleResizeHandler: throttle(this.setViewportSize, 200)
    }
  },
  beforeDestroy () {
    if (!hasWindow()) { return }
    window.removeEventListener('scroll', this.throttleScrollHandler)
    window.removeEventListener('resize', this.throttleResizeHandler)
    this.throttleScrollHandler = null
    this.throttleResizeHandler = null
  },
  mounted () {
    if (!hasWindow()) { return }
    this.setViewportSize()
    this.setViewportScroll()
    window.addEventListener('scroll', this.throttleScrollHandler)
    window.addEventListener('resize', this.throttleResizeHandler)
  },
  methods: {
    setViewportScroll () {
      if (!hasWindow()) { return }
      this.$store.commit('viewport/SET_SCROLL', window.pageYOffset)
    },
    setViewportSize () {
      if (!hasWindow()) { return }
      this.$store.commit('viewport/SET_SIZE', {
        width: window.innerWidth,
        height: window.innerHeight,
        docWidth: document.documentElement.clientWidth
      })
    }
  },
  head () {
    return {
      htmlAttrs: {
        lang: 'de'
      },
      meta: [
        { hid: 'robots', name: 'robots', content: 'index, follow' }
      ]
    }
  }
}
</script>

<style lang="scss">
  @import 'beisheim/scss/cms.scss';
  //---- GLOBALS
  @import 'beisheim/scss/global/reset';
  @import 'beisheim/scss/global/globals';
  @import 'beisheim/scss/global/font-face';
  @import 'beisheim/scss/global/page-transition';
  @import 'beisheim/scss/global/transitions';
  @import 'beisheim/scss/global/inline-editor';
  //----
  @import 'beisheim/scss/colors';
  @import 'beisheim/scss/font';
  @import 'beisheim/scss/fluid-type';
  @import 'beisheim/scss/px-to-rem';
  @import 'beisheim/scss/line-heights';
  @import 'beisheim/scss/breakpoints';

  html {
    @include fluid-type(16px, 19px);
  }

  body {
    @include font(0);
    line-height: line-height(4);
    margin: 0;
    color: gray(1);
    overflow-x: hidden;
  }

  .layout {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
    min-width: $min-width;
    position: relative;
  }

  .layout__header {
    z-index: 2;
  }

  .layout__main {
    position: relative;
    min-height: 100px; // ie flex box height fix
    flex: 1 0 auto;
    background-color: white;
    z-index: 1;
  }

  .layout__footer {
    position: relative;
    z-index: 0;
  }

  .footer-background-fix {
    @include from(4) {
      position: absolute;
      width: 100%;
      height: 100vh;
      top: -50%;
      left: 0;
      background-color: white;
      z-index: 0;
    }
  }

  .container {
    @include grid-spacing(padding-left, 3);
    @include grid-spacing(padding-right, 3);
    display: block;
    margin: 0 auto;
    max-width: $max-width;

    &--small {
      max-width: $small-max-width;
    }
  }
</style>
